// External Dependencies:
import axios from 'axios'
import Cookies from 'js-cookie'
import uuidv4 from 'uuid/v4'

// Internal Dependencies:
import { getAuthToken, clearAuthData } from 'containers/Auth/Auth'
import { getUtcTimestampSeconds } from 'utilities/time'
import { getStorage, setStorage } from 'utilities/storage'
import { getUrlParameter } from 'utilities/url'

// Redux:
import { setScheduleUserData, setSiteId } from 'actions/schedule'

export function checkLoginNudgeState() {
	return function( dispatch, getState ) {
		const { hasLoggedInBefore } = getState().site
		// const { siteId } = getState().schedule
		const siteId = getStorage( 'site_id' )

		const authHasLoggedOutManually = getStorage( 'auth_has_logged_out_manually' )
		const authHasLoggedOutManuallyTimestamp = getStorage( 'auth_has_logged_out_manually_timestamp' )
		const hasSeenLoginNudge = getStorage( 'has_seen_login_nudge' )
		const hasSeenLoginNudgeReminder = getStorage( 'has_seen_login_nudge_reminder' )
		const hasSeenLoginNudgePreviouslyLoggedInReminder = getStorage( 'has_seen_login_nudge_previously_logged_in_reminder' )
		const loginNudgeReminderLastSeenTimestamp = getStorage( 'login_nudge_reminder_last_seen_timestamp' )

		const hourSeconds = 60 * 60
		const daySeconds = hourSeconds * 24
		const monthSeconds = daySeconds * 30
		const previouslyLoggedInUserReminderDelaySeconds = monthSeconds
		const neverLoggedInUserReminderDelaySeconds = monthSeconds

		// const previouslyLoggedInUserReminderDelaySeconds = 60
		// const neverLoggedInUserReminderDelaySeconds = 60

		if ( siteId && ! hasSeenLoginNudge ) {
			dispatch( showLoginNudgeModal( true, 'existing_user' ) )
		}

		if ( siteId && hasSeenLoginNudge && loginNudgeReminderLastSeenTimestamp && ! hasLoggedInBefore ) {
			const timeNow = getUtcTimestampSeconds()
			const timeToShow = ( parseInt( loginNudgeReminderLastSeenTimestamp, 10 ) + neverLoggedInUserReminderDelaySeconds )

			// Only show if a month has passed:
			if ( timeNow > timeToShow ) {
				dispatch( showLoginNudgeModal( true, 'existing_user_reminder' ) )
			}
		}

		if ( siteId && hasSeenLoginNudge && hasLoggedInBefore ) {
			if ( authHasLoggedOutManually && authHasLoggedOutManuallyTimestamp ) {
				const timeNow = getUtcTimestampSeconds()
				const timeToShow = ( parseInt( authHasLoggedOutManuallyTimestamp, 10 ) + previouslyLoggedInUserReminderDelaySeconds )

				// Only show if a month has passed:
				if ( timeNow > timeToShow ) {
					dispatch( showLoginNudgeModal( true, 'previously_logged_in_user_reminder' ) )
				}
			} else {
				// If auto-loggged out: show the nudge immediately:
				dispatch( showLoginNudgeModal( true, 'previously_logged_in_user_reminder' ) )
			}
		}
	}
}

export function getScreenSize() {
	return {
		type: 'GET_SCREEN_SIZE'
	}
}

export function openMenu() {
	return {
		type: 'OPEN_MENU'
	}
}

export function closeMenu() {
	return {
		type: 'CLOSE_MENU'
	}
}

export function closeAccountDropdown() {
	return {
		type: 'CLOSE_ACCOUNT_DROPDOWN'
	}
}

export function toggleAccountDropdown() {
	return {
		type: 'TOGGLE_ACCOUNT_DROPDOWN'
	}
}

export function setSidebarVisibility( val ) {
	return {
		type: 'SET_SIDEBAR_VISIBILITY',
		payload: val
	}
}

export function setDismissedInstallAppBanner() {
	Cookies.set( 'dismissed_install_app_banner', '1' )

	return {
		type: 'SET_DISMISSED_INSTALL_WEB_APP_IOS_BANNER'
	}
}

export function setHasSeenVotdIntro() {
	Cookies.set( 'has_seen_votd_intro', '1' )

	return {
		type: 'SET_HAS_SEEN_VOTD_INTRO'
	}
}

export function setHasNotSeenVotdIntro() {
	return {
		type: 'SET_HAS_NOT_SEEN_VOTD_INTRO'
	}
}

export function setScrollTopButtonVisibility( bool ) {
	return {
		type: 'SET_SCROLL_TOP_BUTTON_VISIBILITY',
		payload: bool
	}
}

export function setHasScrolledToProgramsPage( bool = true ) {
	return {
		type: 'SET_HAS_SCROLLED_TO_PROGRAMS_PAGE',
		payload: bool
	}
}

export function receiveUserData( data ) {
	return {
		type: 'RECEIVE_ACCOUNT_DATA',
		payload: data
	}
}

export function receiveUserLikesData( data ) {
	return {
		type: 'RECEIVE_ACCOUNT_LIKES_DATA',
		payload: data
	}
}

export function receiveUserLikesDataPartB() {
	return {
		type: 'RECEIVE_ACCOUNT_LIKES_DATA_PART_B'
	}
}

export function receiveUserDataListenTime( data ) {
	return {
		type: 'RECEIVE_ACCOUNT_DATA_LISTEN_TIME',
		payload: data
	}
}

export function addScript( value ) {
	return {
		type: 'ADD_SCRIPT',
		value: value
	}
}

export function getAccountData() {
	return function( dispatch, getState ) {
		const token = getAuthToken()

		return axios( {
				url: siteData.api_base_url + 'user',
				timeout: 20000,
				method: 'GET',
				responseType: 'json',
				headers: {
					'Authorization': `Bearer ${token}`
				},
				withCredentials: true
			} )
			.then( response => {
				if ( response.data ) {
					// Force log out adventist-profile users:
					if ( response.data.user_id.includes( 'adventist-profile' ) ) {
						dispatch( receiveUserData( {} ) )
						dispatch( setScheduleUserData( {} ) )
						clearAuthData()
						dispatch( checkLoginNudgeState() )

						return
					}

					dispatch( receiveUserData( response.data ) )
					dispatch( setScheduleUserData( response.data ) )

					if ( response.data.site_id && ! getUrlParameter( 'siteid' ) ) {
						dispatch( setSiteId( response.data.site_id ) )
					}

					if ( ! response.data.badges || ! response.data.badges.account ) {
						dispatch( awardBadge( 'account' ) )

						const { siteId, userLocation, timezoneType, userTimezoneOffset, userChurchName, userPhone } = getState().schedule

						dispatch( updateAccount( {
							site_id: siteId,
							site_search: userLocation,
							timezone_type: timezoneType,
							user_timezone_offset: userTimezoneOffset,
							church_name: userChurchName,
							phone: userPhone
						} ) )
					}
				}
			} )
			.catch( error => {
				if ( error.response ) {
					console.error( error.response, 'error.response' )

					dispatch( receiveUserData( {} ) )
					dispatch( setScheduleUserData( {} ) )
					clearAuthData()
					dispatch( checkLoginNudgeState() )
				}
			} )
	}
}

export function getAccountLikesData() {
	return function( dispatch, getState ) {
		const token = getAuthToken()
		const { hasReceivedLikesData } = getState().site

		if ( hasReceivedLikesData ) {
			return
		}

		return axios( {
				url: siteData.api_base_url + 'user-likes',
				timeout: 20000,
				method: 'GET',
				responseType: 'json',
				headers: {
					'Authorization': `Bearer ${token}`
				},
				withCredentials: true
			} )
			.then( response => {
				if ( response.data ) {
					dispatch( receiveUserLikesData( response.data ) )

					// Add delay before setting hasReceivedLikesData to avoid flash of empty state:
					setTimeout( () => {
						dispatch( receiveUserLikesDataPartB() )
					}, 1000 )
				}
			} )
			.catch( error => {
				if ( error.response ) {
					console.error( error.response, 'error.response' )
				}
			} )
	}
}

export function updateAccount( {
	name = false,
	email = false,
	password = false,
	church_name = false,
	phone = false,
	add_listen_time_seconds = false,
	site_id = false,
	site_search = false,
	timezone_type = false,
	user_timezone_offset = false
} = {} ) {
	return function( dispatch, getState ) {
		const token = getAuthToken()
		const user_id = getState().site.accountData.sub

		let data = {
			user_id: user_id
		}

		if ( name ) {
			data.name = name
		}

		if ( email ) {
			data.email = email
		}

		if ( password ) {
			data.password = password
		}

		if ( church_name ) {
			data.church_name = church_name
		}

		if ( phone ) {
			data.phone = phone
		}

		if ( site_id ) {
			data.site_id = site_id
		}

		if ( site_search ) {
			data.site_search = site_search
		}

		if ( timezone_type ) {
			data.timezone_type = timezone_type
		}

		if ( user_timezone_offset ) {
			data.user_timezone_offset = user_timezone_offset
		}

		if ( add_listen_time_seconds ) {
			let listen_time_seconds = getState().site.accountData['listen_time_seconds']

			if ( ! listen_time_seconds ) {
				listen_time_seconds = 0
			}

			data.listen_time_seconds = parseInt( listen_time_seconds, 10 ) + add_listen_time_seconds
		}

		return axios( {
				url: siteData.api_base_url + 'save-profile',
				timeout: 20000,
				method: 'POST',
				responseType: 'json',
				headers: {
					'Authorization': `Bearer ${token}`
				},
				withCredentials: true,
				data: data
			} )
			.then( response => {
				if ( response.data ) {
					if ( add_listen_time_seconds ) {
						dispatch( receiveUserDataListenTime( response.data.listen_time_seconds ) )
					} else {
						dispatch( receiveUserData( response.data ) )
					}

					if ( data.listen_time_seconds ) {
						if ( data.listen_time_seconds > ( 60 * 60 * 3 ) ) {
							dispatch( awardBadge( 'listen_3_hours' ) )
						}

						if ( data.listen_time_seconds > ( 60 * 60 * 25 ) ) {
							dispatch( awardBadge( 'listen_25_hours' ) )
						}

						if ( data.listen_time_seconds > ( 60 * 60 * 100 ) ) {
							dispatch( awardBadge( 'listen_100_hours' ) )
						}
					}
				}
			} )
			.catch( error => {
				if ( error.response ) {
					console.error( error.response, 'error.response' )
				}
			} )
	}
}

export function deleteAccount() {
	return function( dispatch, getState ) {
		const token = getAuthToken()
		const user_id = getState().site.accountData.sub

		let data = {
			user_id: user_id
		}

		return axios( {
				url: siteData.api_base_url + 'delete-account',
				timeout: 20000,
				method: 'POST',
				responseType: 'json',
				headers: {
					'Authorization': `Bearer ${token}`
				},
				withCredentials: true,
				data: data
			} )
			.then( response => {
				if ( response.data ) {
					dispatch( receiveUserData( {
						deleted: true
					} ) )
					dispatch( setScheduleUserData( {} ) )

					clearAuthData()
				}
			} )
			.catch( error => {
				if ( error.response ) {
					console.error( error.response, 'error.response' )
				}
			} )
	}
}

export function showLoginNudgeModal( state, type = '' ) {
	return {
		type: 'SHOW_LOGIN_NUDGE_MODAL',
		payload: {
			state,
			type
		}
	}
}

export function awardBadge( badge ) {
	return function( dispatch, getState ) {
		const token = getAuthToken()
		const { badges } = getState().site.accountData

		if ( badges && badges[ badge ] ) {
			return
		}

		return axios( {
				url: siteData.api_base_url + 'award-badge',
				timeout: 20000,
				method: 'POST',
				responseType: 'json',
				headers: {
					'Authorization': `Bearer ${token}`
				},
				withCredentials: true,
				data: {
					badge
				}
			} )
			.then( response => {
				if ( response.data ) {
					dispatch( receiveUserData( response.data ) )
					dispatch( setScheduleUserData( response.data ) )
					dispatch( showBadgeAwardModal( badge ) )
				}
			} )
			.catch( error => {
				if ( error.response ) {
					console.error( error.response, 'error.response' )
				}
			} )
	}
}

export function showBadgeAwardModal( badge ) {
	return {
		type: 'SHOW_BADGE_AWARD_MODAL',
		payload: badge
	}
}

export function likeProgram( program, keepInState = false ) {
	return function( dispatch, getState ) {
		const token = getAuthToken()
		const { accountData } = getState().site
		let isLiked = false

		if ( accountData && accountData.likes && accountData.likes[ program.audio_file_url ] ) {
			isLiked = ! accountData.likes[ program.audio_file_url ].is_removed
		}

		const state = isLiked ? 'unlike' : 'like'

		// Don't wait for a response before updating the ui.
		dispatch( receiveUserDataLike( state, program, keepInState ) )

		return axios( {
				url: siteData.api_base_url + 'like-program',
				timeout: 20000,
				method: 'POST',
				responseType: 'json',
				headers: {
					'Authorization': `Bearer ${token}`
				},
				withCredentials: true,
				data: {
					state,
					program_key: program.audio_file_url,
					program_title: program.title,
					program_series_slug: program.series_slug
				}
			} )
			.then( response => {

			} )
			.catch( error => {
				if ( error.response ) {
					console.error( error.response, 'error.response' )
				}
			} )
	}
}

export function receiveUserDataLike( state, program, keepInState ) {
	return {
		type: 'RECEIVE_ACCOUNT_DATA_LIKE',
		payload: {
			state,
			program,
			keepInState
		}
	}
}

export function cleanupRemovedLikes() {
	return {
		type: 'CLEANUP_REMOVED_LIKES'
	}
}

export function showProgramMenu( program, source = '' ) {
	return {
		type: 'SHOW_PROGRAM_MENU',
		payload: {
			program,
			source
		}
	}
}

export function hideProgramMenu() {
	return {
		type: 'HIDE_PROGRAM_MENU'
	}
}

export function showSiteNotice( {
	heading = '',
	text = '',
	cancelText = 'Cancel',
	actions = []
} = {} ) {
	return {
		type: 'SHOW_SITE_NOTICE',
		payload: {
			heading,
			text,
			cancelText,
			actions
		}
	}
}

export function hideSiteNotice() {
	return {
		type: 'HIDE_SITE_NOTICE'
	}
}

export function getShareLinkData( id ) {
	return function( dispatch, getState ) {
		return axios( {
				url: siteData.api_base_url + 'share-link?id=' + id,
				timeout: 20000,
				method: 'GET',
				responseType: 'json'
			} )
			.then( response => {
				dispatch( receiveShareLinkData( response.data ) )
			} )
			.catch( error => {
				if ( error.response ) {
					console.error( error.response, 'error.response' )
				}
			} )
	}
}

export function receiveShareLinkData( data ) {
	return {
		type: 'RECEIVE_SHARE_LINK_DATA',
		payload: data
	}
}

export function saveShareLink( id, program_slug, file_url ) {
	return function( dispatch, getState ) {
		const { accountData } = getState().site
		let analytics_uid

		if ( accountData && accountData.analytics_uid ) {
			analytics_uid = accountData.analytics_uid
		} else if ( Cookies.get( 'analytics_uid' ) ) {
			analytics_uid = Cookies.get( 'analytics_uid' )
		} else {
			analytics_uid = uuidv4()
			Cookies.set( 'analytics_uid', analytics_uid )
		}

		return axios( {
				url: siteData.api_base_url + 'share-link',
				timeout: 20000,
				method: 'POST',
				responseType: 'json',
				data: {
					id,
					program_slug,
					file_url,
					analytics_uid
				}
			} )
			.then( response => {

			} )
			.catch( error => {
				if ( error.response ) {
					console.error( error.response, 'error.response' )
				}
			} )
	}
}
